import { render, staticRenderFns } from "./PorGrupo.vue?vue&type=template&id=7e2b7cb2&scoped=true&lang=pug&"
import script from "./PorGrupo.vue?vue&type=script&lang=js&"
export * from "./PorGrupo.vue?vue&type=script&lang=js&"
import style0 from "./PorGrupo.vue?vue&type=style&index=0&id=7e2b7cb2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2b7cb2",
  null
  
)

export default component.exports